<div class="modal-header d-flex justify-content-center border-0">
  <h4 class="modal-title text-color fw-bold mt-3">
    Asignar estatus de entrega
  </h4>
</div>
<div class="modal-body text-center pt-0">
  <form
    [formGroup]="orderStatusForm"
    (ngSubmit)="onSubmit()"
    class="w-100 pt-2"
  >
    <div
      class="container d-flex flex-column justify-content-center align-items-center"
    >
      <div class="form-group w-75">
        <div class="form-floating">
          <select id="estatus" class="form-select" formControlName="estatus">
            <option value="Nuevo">Nuevo</option>
            <option value="En proceso">En proceso</option>
            <option value="Terminado">Terminado</option>
            <option value="Cancelado">Cancelado</option>
          </select>
          <label for="state">Estatus de entrega</label>
        </div>
        <div class="text-danger pt-1">
          {{ estatusErrors }}
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button
        class="btn btn-primary bg-ligth-mode ps-5 mt-5 pt-2 pb-2 pe-5"
        type="submit"
        [disabled]="orderStatusForm.invalid || submitted"
      >
        Confirmar
      </button>
    </div>
    <div class="d-flex justify-content-center"></div>
    <label class="clickable text-ligth-mode fw-bolder mt-3" (click)="close()">
      Cancelar
    </label>
  </form>
</div>
